import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Items, ItemState } from "@/types/organization";

const initialState: ItemState = {
  items: [],
};

export const itemSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<Items>) => {
      const newTag: Items = {
        ...action.payload,
      };
      state.items.push(newTag);
    },

    setItems: (state, action: PayloadAction<Items[]>) => {
      state.items = action.payload;
    },
    updateItem: (state, action: PayloadAction<Items>) => {
      const index = state.items.findIndex(
        (item) => item.id === action.payload.id,
      );
      if (index !== -1) {
        Object.assign(state.items[index], action.payload);
      }
    },

    deleteItem: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
  },
});

export const {
  addItem,

  updateItem,
  deleteItem,
  setItems,
} = itemSlice.actions;

export default itemSlice.reducer;
